/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var ProOnly = require('../../../../widgets/ProOnly');
var AttachedFiles = require('./AttachedFiles');
var TemplateLibrary = require('./TemplateLibrary');
var RelayOpportunity = require('./RelayOpportunity');

module.exports = dd.createClass({
	render: function(){
		var event = this.props.event;
		var Displaylists = this.props.Displaylists;

		return dd.div({className: 'Library'},
			ProOnly({
					sids: event.sids,
					custom_message: 'PRO users attach files like contracts and presentations right to the event so they are always available. Upload Word and Excel template documents and generate contracts, thank-you letters, and more with a touch.'
				},
				dd.h2(null, 'Library'),

				(_.get(event, ["relay"], 0) > 0 ? RelayOpportunity({event: event, Displaylists: Displaylists}) : null),

				AttachedFiles({event: event, Displaylists: Displaylists}),

				TemplateLibrary({event: event, Displaylists: Displaylists})
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/library/index.js